import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateOrgFeatureFlagsMutationVariables = Types.Exact<{
  input: Types.UpdateOrgFeatureFlagsInput;
}>;


export type UpdateOrgFeatureFlagsMutation = { __typename?: 'Mutation', updateOrgFeatureFlags: { __typename?: 'BaseMutationResult', success: boolean } };

export type OrgFeatureFlagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrgFeatureFlagsQuery = { __typename?: 'Query', OrgFeatureFlags: Array<{ __typename?: 'FeatureFlag', name: string, enabled: boolean }> };

export type SetOrgFeatureFlags_FeatureFlagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SetOrgFeatureFlags_FeatureFlagsQuery = { __typename?: 'Query', FeatureFlags: Array<{ __typename?: 'FeatureFlag', name: string, enabled: boolean, userFacingName?: string | null, staffSelfServableForOrg?: boolean | null }> };


export const UpdateOrgFeatureFlagsDocument = gql`
    mutation UpdateOrgFeatureFlags($input: UpdateOrgFeatureFlagsInput!) {
  updateOrgFeatureFlags(input: $input) {
    success
  }
}
    `;
export type UpdateOrgFeatureFlagsMutationFn = Apollo.MutationFunction<UpdateOrgFeatureFlagsMutation, UpdateOrgFeatureFlagsMutationVariables>;

/**
 * __useUpdateOrgFeatureFlagsMutation__
 *
 * To run a mutation, you first call `useUpdateOrgFeatureFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgFeatureFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgFeatureFlagsMutation, { data, loading, error }] = useUpdateOrgFeatureFlagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgFeatureFlagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgFeatureFlagsMutation, UpdateOrgFeatureFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgFeatureFlagsMutation, UpdateOrgFeatureFlagsMutationVariables>(UpdateOrgFeatureFlagsDocument, options);
      }
export type UpdateOrgFeatureFlagsMutationHookResult = ReturnType<typeof useUpdateOrgFeatureFlagsMutation>;
export type UpdateOrgFeatureFlagsMutationResult = Apollo.MutationResult<UpdateOrgFeatureFlagsMutation>;
export type UpdateOrgFeatureFlagsMutationOptions = Apollo.BaseMutationOptions<UpdateOrgFeatureFlagsMutation, UpdateOrgFeatureFlagsMutationVariables>;
export const OrgFeatureFlagsDocument = gql`
    query OrgFeatureFlags {
  OrgFeatureFlags {
    name
    enabled
  }
}
    `;

/**
 * __useOrgFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useOrgFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<OrgFeatureFlagsQuery, OrgFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgFeatureFlagsQuery, OrgFeatureFlagsQueryVariables>(OrgFeatureFlagsDocument, options);
      }
export function useOrgFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgFeatureFlagsQuery, OrgFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgFeatureFlagsQuery, OrgFeatureFlagsQueryVariables>(OrgFeatureFlagsDocument, options);
        }
export type OrgFeatureFlagsQueryHookResult = ReturnType<typeof useOrgFeatureFlagsQuery>;
export type OrgFeatureFlagsLazyQueryHookResult = ReturnType<typeof useOrgFeatureFlagsLazyQuery>;
export type OrgFeatureFlagsQueryResult = Apollo.QueryResult<OrgFeatureFlagsQuery, OrgFeatureFlagsQueryVariables>;
export const SetOrgFeatureFlags_FeatureFlagsDocument = gql`
    query SetOrgFeatureFlags_FeatureFlags {
  FeatureFlags {
    name
    enabled
    userFacingName
    staffSelfServableForOrg
  }
}
    `;

/**
 * __useSetOrgFeatureFlags_FeatureFlagsQuery__
 *
 * To run a query within a React component, call `useSetOrgFeatureFlags_FeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetOrgFeatureFlags_FeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetOrgFeatureFlags_FeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSetOrgFeatureFlags_FeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<SetOrgFeatureFlags_FeatureFlagsQuery, SetOrgFeatureFlags_FeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SetOrgFeatureFlags_FeatureFlagsQuery, SetOrgFeatureFlags_FeatureFlagsQueryVariables>(SetOrgFeatureFlags_FeatureFlagsDocument, options);
      }
export function useSetOrgFeatureFlags_FeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SetOrgFeatureFlags_FeatureFlagsQuery, SetOrgFeatureFlags_FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SetOrgFeatureFlags_FeatureFlagsQuery, SetOrgFeatureFlags_FeatureFlagsQueryVariables>(SetOrgFeatureFlags_FeatureFlagsDocument, options);
        }
export type SetOrgFeatureFlags_FeatureFlagsQueryHookResult = ReturnType<typeof useSetOrgFeatureFlags_FeatureFlagsQuery>;
export type SetOrgFeatureFlags_FeatureFlagsLazyQueryHookResult = ReturnType<typeof useSetOrgFeatureFlags_FeatureFlagsLazyQuery>;
export type SetOrgFeatureFlags_FeatureFlagsQueryResult = Apollo.QueryResult<SetOrgFeatureFlags_FeatureFlagsQuery, SetOrgFeatureFlags_FeatureFlagsQueryVariables>;